export default __webpack_public_path__ + "static/media/home-banner.892d9901.svg";